import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import React from "react";

const useStyles = makeStyles(
  {
    content: {
      alignItems: "center",
      display: "inline-flex",
      paddingBottom: "0 !important",
      paddingTop: "0 !important"
    },
    icon: {
      height: "45px",
      marginRight: 15
    },
    lineOne: {
      paddingBottom: 0,
      paddingTop: 0,
      textAlign: "left"
    },
    root: {
      "&:before": {
        backgroundColor: "#accaff",
        bottom: -7,
        content: "' '",
        height: 20,
        position: "absolute",
        right: 85,
        transform: "rotate(45deg)",
        width: 20
      },
      backgroundColor: "#accaff",
      border: "1px solid #accaff",
      bottom: "-13px",
      color: "#373f4c",
      fontSize: "13px",
      paddingBottom: 5,
      paddingTop: 5,
      position: "absolute",
      right: "0px",
      transform: "translateY(-75px) translateX(-15px)",
      width: "20%"
    }
  },
  { name: "StoreOrderSMACCard" }
);

export interface StoreOrderInStoreTooltipProps {
  visible?: boolean;
  text: string;
}

const StoreOrderInStoreTooltip: React.SFC<StoreOrderInStoreTooltipProps> = props => {
  const classes = useStyles(props);

  const { visible = false, text } = props;

  if (!visible) {
    return <></>;
  }

  return (
    <Card className={classes.root}>
      <CardContent className={classes.content}>
        <InfoOutlinedIcon className={classes.icon} />
        <div
          style={{
            paddingBottom: "0",
            zIndex: 1
          }}
        >
          <div className={classes.lineOne}>
            {" "}
            <span>{text}</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default StoreOrderInStoreTooltip;
